
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"13","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.535 1.344a.418.418 0 01.14-.158.346.346 0 01.2-.065 1.904 1.904 0 011.33.557 1.866 1.866 0 01.545 1.318v1.629h2.46a1.38 1.38 0 011.044.475 1.4 1.4 0 01.287.515c.059.192.072.389.041.592l-.691 4.5a1.363 1.363 0 01-.47.838 1.338 1.338 0 01-.901.334H1.383a1.365 1.365 0 01-.979-.404A1.374 1.374 0 010 10.496V7.004a1.367 1.367 0 01.404-.979 1.375 1.375 0 01.979-.404h1.254l1.898-4.277zM3.258 6.078v5.05H8.52a.63.63 0 00.416-.151.606.606 0 00.216-.387l.692-4.5a.614.614 0 00-.153-.498.607.607 0 00-.48-.217H6.375a.36.36 0 01-.264-.111A.36.36 0 016 5V2.996c0-.266-.084-.502-.252-.709a1.093 1.093 0 00-.639-.392L3.258 6.078zm-.75 5.05V6.372H1.383a.608.608 0 00-.446.188.608.608 0 00-.187.445v3.492c0 .172.063.32.188.445a.608.608 0 00.445.188h1.125z","fill":"#24AE64"}})])
          )
        }
      }
    